import { getEnv } from '@luna/env';

import { clientOptionsFactory } from './lib/clientOptions';

clientOptionsFactory.set(() => ({ baseUrl: `${getEnv().apiGatewayUrl}message` }));
